import React from 'react'
import './Footer.scss'
import { Link } from 'react-router-dom'
import urlGenerator from '$ustoreinternal/services/urlGenerator'
import {t} from "../../localizations";

const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <div className="footer">
      <div className="footer__logo">
        <img src={require('$assets/images/logo.png')} alt="Vögeli AG" />
      </div>
      <div className="footer__copy">
        © {year} Vögeli AG, {t('Footer.Copyright')}
      </div>
      <div className="footer__links">
        <Link to={urlGenerator.get({ page: 'AGB' })}>{t('Footer.AGB')}</Link>
        <Link to={urlGenerator.get({ page: 'Impressum' })}>{t('Footer.Impressum')}</Link>
        <Link to={urlGenerator.get({ page: 'Datenschutz' })}>{t('Footer.Datenschutz')}</Link>
      </div>
    </div>
  )
}

export default Footer
